import { render, staticRenderFns } from "./SignUpReward.vue?vue&type=template&id=4062a2a3&scoped=true"
import script from "./SignUpReward.vue?vue&type=script&lang=js"
export * from "./SignUpReward.vue?vue&type=script&lang=js"
import style0 from "./SignUpReward.vue?vue&type=style&index=0&id=4062a2a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4062a2a3",
  null
  
)

export default component.exports